import { useEffect } from "preact/hooks";
import { exchangeGithubCode } from "~/services/api";


const GithubCallback = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");

  useEffect(() => {
    exchangeGithubCode(code || "")
      .then((data) => {
        localStorage.setItem("jwtToken", data.jwtToken);
        window.close();
      })
      .catch(() => {
        // 失败则跳转回首页
        window.location.href = "/";
      });

  }, []);
  return <div>Github 回调处理中...</div>;
};

export default GithubCallback;
